import { call, put, select, takeLatest } from "redux-saga/effects";
import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";

// Initial state
const initialState = {
  loading: null,
  error: false,
  loaded: null,
  data: null,
  agentList: [],
  rowsCount: null,
  infinity: true,
};

// Slice
const afterServiceAgentSlice = createSlice({
  name: "afterServiceAgent",
  initialState,
  reducers: {
    findAgent(state) {
      return {
        ...state,
        agentList: [],
        loading: true,
        error: false,
        infinity: true,
      };
    },
    findMoreAgent(state) {
      return { ...state, loading: true, error: false };
    },
    fetchDataSuccess(state, action) {
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: false,
        loaded: true,
      };
    },
    fetchDataFailure(state, action) {
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: action.payload,
        loaded: true,
      };
    },
    setAgentList(state, action) {
      const { items, rowsCount } = action.payload;
      return {
        ...state,
        agentList: [...state.agentList, ...items],
        rowsCount,
      };
    },
    sefInfinity(state) {
      return {
        ...state,
        infinity: false,
      };
    },
  },
});

export const {
  findAgent,
  findMoreAgent,
  fetchDataSuccess,
  fetchDataFailure,
  setAgentList,
  sefInfinity,
} = afterServiceAgentSlice.actions;

export default afterServiceAgentSlice.reducer;

function* fetchDataSaga(action) {
  try {
    const currentDataLength = yield select(
      (state) => state.afterServiceAgent.agentList.length
    );
    const rowsCount = yield select(
      (state) => state.afterServiceAgent.rowsCount
    );
    const peerIp = yield select((state) => state.peerIp.ip);
    if (rowsCount !== null && currentDataLength >= rowsCount) {
      // 이미 모든 데이터를 불러왔을 경우, 추가 요청하지 않음
      yield put(sefInfinity());
      return;
    }
    const { headers = {}, apiUrl } = action.payload;
    const apiService = axios.create({
      headers: {
        ...headers,
        user_ip: peerIp
      },
    });

    const response = yield call(apiService.get, apiUrl);
    yield put(fetchDataSuccess(response.data));

    if (response?.data) {
      const { code, rowsCount, items } = response.data;
      if (code === "0000") {
        yield put(setAgentList({ rowsCount, items }));
      }
    }
  } catch (error) {
    yield put(fetchDataFailure(error));
  }
}

// API 호출을 감시하는 Saga 함수
export function* afterServiceAgentSaga() {
  yield takeLatest(findAgent.type, fetchDataSaga);
  yield takeLatest(findMoreAgent.type, fetchDataSaga);
}
